module.exports = __webpack_public_path__ + "01_bob_brown.d45f85e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/01_bob_brown.png
// module id = B2ju
// module chunks = 0